import { FORM_CENTER_LIMIT_NUMBER, GIRD_SYSTEM_FORM_CENTER } from '../../../common/constants/Defines';
import { FormsCounterService } from '../../services/forms-counter/forms-counter.service';
import { TrackingHandlerService } from '../../services/tracking/tracking-handler.service';
import * as pagesConfig from '../../../../config/pages-config';
import { TRACKING_FORM } from '../../defines/tracking.defines';
import { RouterService } from '../../services/router.service';
import { TranslateService } from '@ngx-translate/core';
import { MODULES_NAMES } from '../../defines/defines';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

/** center hub component */
@Component ({
  selector: 'center-hub',
  templateUrl: './center-hub.component.html',
  styleUrls: ['./center-hub.scss'],
})
export class CenterHubComponent implements OnInit {
  /** forms array */
  public formsArray: any = [];
  /** paginationFormsArray */
  public paginationFormsArray: Array<object> = [];
  /** paginationData */
  public paginationData: any;
  /** allformsArray */
  public allformsArray = [];
   /** searchInputConfig */
   public searchInputConfig;
   /** textHeaderConfig */
   public textHeaderConfig;
   /** deWordingPath */
  public deWordingPath: string;
  /** gridContainerConfig */
  public gridColumns;
  /** FORM_CENTER_LIMIT_NUMBER */
  public formsCount;

  /**
   * @param FormsCounterService FormsCounterService
   * @param ts TranslateService
   * @param router Router
   */
  public constructor (
    private FormsCounterService: FormsCounterService,
    private ts: TranslateService,
    private router: Router,
    private routerService: RouterService,
    private trackingHandlerService: TrackingHandlerService,
  ) {
    /** setCurrentModule */
    this.routerService.setCurrentModule(MODULES_NAMES.centerHub);
  }

/** ngOnInit */
  public ngOnInit (): void {
    this.deWordingPath = 'FromCenterModule.hubPage.';
    this.formsCount = FORM_CENTER_LIMIT_NUMBER;
    this.gridColumns = GIRD_SYSTEM_FORM_CENTER;
    this.getHubCenterForms();
    this.setSearchBarObject();
    this.setHeaderObject();
    this.firePageView();
  }

  /**
   * firePageView
   * @returns void
   */
  public firePageView (): void {
    const hubTracking =  TRACKING_FORM.CENTERHUB.siteStructure;
    this.trackingHandlerService.trackPageView(hubTracking);
  }
    /** getHubCenterForms
     *  @returns {void} - void
     */
    public getHubCenterForms (): void {

    this.FormsCounterService.getFormCenterForms().subscribe(res => {
      const data: Array<any> = res.filter(form => form.listed === true);
      let formListItem = {};
      for (const form of data) {
        formListItem = {
          imgPath: '/simplicity/assets/img/mediaelements/decorative-icon.svg',
          headline: form.name,
          text: form.keywords,
          moreInfoText: this.ts.instant(this.deWordingPath + 'formListItem.moreInfoBtn.std-headline'),
          systemIcon: this.ts.instant(this.deWordingPath + 'formListItem.systemIcon.opt-icon'),
          target: '_self',
          routerLink: `/${form.Id}`,
        },
       this.formsArray.push(formListItem);
       this.paginationFormsArray.push(formListItem);
      }
      this.initPaginationData();
      this.formsArray = this.formsArray.slice(0, this.paginationData.numberOfItemsPerPage);
      this.allformsArray = this.formsArray.map(formElement => Object.assign({}, formElement));
    }, () => {
        this.router.navigate([pagesConfig.config.generalError.route]);
  });
  }

  /** FliterFormList
   *  @param searchvalue - name or keyword that search for
   */
  public FliterFormList (searchvalue) {
    if (!searchvalue) {
      this.formsArray = this.allformsArray;
    }
    searchvalue = searchvalue.toLowerCase();
    this.formsArray = this.formsArray.filter(item => {

      return ( item.text.find(a => a.toLowerCase().includes(searchvalue)) || item.headline.toLowerCase().includes(searchvalue)
             );
    });
  }
  /** setSearchBar
   *  @returns void
   */
  public setSearchBarObject (): void {
    this.searchInputConfig = {
      textInputConfig: {
          id: 'input_id1',
          type: 'text',
          systemIcon: 'dialog-close',
          name: 'centerHubSearchBar',
          placeholder: this.ts.instant(this.deWordingPath + 'searchBarContent.std-subHeadline'),
          isNotificationIconDisabled: true,
          hideValidationStyle: true,
          automation_id: 'searchBar_ID',
          maxLength: 50,
      },
      buttonIconOnlyConfig: {
          automation_id: 'button_wf',
          systemIconConfig: {
              systemIconName: 'search',
              additionalClassName: 'ws10-button-icon-only__icon',
              automation_id: 'true',
          },
      },
   };
  }
  /** setSearchBar
   *  @returns void
   */
  public setHeaderObject (): void {

      this.textHeaderConfig = {
      automation_id: 'form_center_headline_id',
      headlineText: this.ts.instant(this.deWordingPath + 'headerContent.std-headline'),
      sublineText: this.ts.instant(this.deWordingPath + 'headerContent.std-subHeadline'),
    };
  }

  /** onNextPage
   * @description to update and slice data from formsArray in the next page
   * @returns void
   */
   public onNextPage (): void {
    const startIndex = (this.paginationData.currentPage - 1 ) * this.paginationData.numberOfItemsPerPage;
    const endIndex = startIndex + this.paginationData.numberOfItemsPerPage;

    this.formsArray = this.paginationFormsArray.filter((item, index) => {
      return index >= startIndex && index < endIndex;
    });

    this.paginationData.currentPage + 1;
  }

  /** onPrevPage
   * @description to update and slice data from formsArray in the prev page
   *  @returns void
   */
  public onPrevPage (): void {
    if (this.paginationData.currentPage >= 1) {
      const startIndex = (this.paginationData.currentPage - 1) * this.paginationData.numberOfItemsPerPage;
      const endIndex = startIndex + this.paginationData.numberOfItemsPerPage;

      this.formsArray = this.paginationFormsArray.filter((item, index) => {
        return index >= startIndex && index < endIndex;
      });

      this.paginationData.currentPage - 1;
    }
  }

  /** initPaginationData
   * @description to inialize pagination data that will send to ws10-pagination
   * @returns void
   */
  public initPaginationData (): void {
    this.paginationData = {
      totalPages: this.paginationFormsArray?.length,
      currentPage: 1,
      numberOfItemsPerPage: 10,
    };
  }

}
